import { render, staticRenderFns } from "./ProductAmountRangeItem.vue?vue&type=template&id=199c8b18&lang=pug&"
import script from "./ProductAmountRangeItem.vue?vue&type=script&lang=js&"
export * from "./ProductAmountRangeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports